/* eslint-disable */
export default {
    state: {
        isLogin: false,
        adminer: {},
        menus: [],
        info: {}
    },
    mutations: {
        switch_login (state) {
            if (localStorage.isLogin !== undefined && localStorage.isLogin !== 'false') {
                state.isLogin = true
            } else {
                state.isLogin = false
            }

            if (localStorage.adminer !== undefined && localStorage.adminer.length) {
                state.adminer = JSON.parse(localStorage.adminer)
            } else {
                state.adminer = {}
            }

            if (localStorage.menus !== undefined && localStorage.menus.length) {
                state.menus = JSON.parse(localStorage.menus)
            } else {
                state.menus = []
            }

            if (localStorage.loginInfo !== undefined && localStorage.loginInfo.length) {
                state.info = JSON.parse(localStorage.loginInfo)
            } else {
                state.info = {}
            } 
        }
    }
}




// WEBPACK FOOTER //
// ./src/global/store/loginState.js